import ManageAuditioneesTab from "./sub_tabs/ManageAuditioneesTab";
import OrganisationMembers from "./sub_tabs/OrganisationMembers";


const dataAndAccountsRouter = {

  auditionees: 
  {
    title: 'Auditionees',
    element: <ManageAuditioneesTab />
  },

  accounts: 
  {
    title: 'Organisation Members',
    element: <OrganisationMembers />
  },

}

export default dataAndAccountsRouter;